"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function Picture(props) {
    var srcTest = props.src ? props.src.match(/(.*)\.(jpg|png)$/) : undefined;
    return (jsx_runtime_1.jsxs("picture", { children: [srcTest && jsx_runtime_1.jsx("source", { srcSet: srcTest[1] + '.webp' }, void 0),
            jsx_runtime_1.jsx("img", __assign({ alt: props.alt }, props), void 0)] }, void 0));
}
exports.default = Picture;
//# sourceMappingURL=Picture.js.map